import {renderColumnValue} from "../../../General/SharedMethods";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField} from "@mui/material";
import CatalogEntity from "../Components/CatalogEntity";
import * as yup from "yup";

const RegionEditor = ({enums}) => {

    const ViewRegionDialog = (columns, viewRow, setViewRow) => {
        const components = [];
        for (let i = 0; i < columns.length; i += 1) {
            components.push(
                <Grid container spacing={2} marginBottom={1} padding={1} key={`row-${i}`}>
                    {[...Array(1)].map((_, j) => {
                        const column = columns[i + j];
                        return column && (
                            <Grid item xs={12} sm={12} key={column.accessorKey}>
                                <TextField
                                    label={column.header}
                                    defaultValue={renderColumnValue(column, viewRow, enums)}
                                    InputProps={{readOnly: true}}
                                    variant="standard"
                                    fullWidth
                                />
                            </Grid>
                        );
                    })}
                </Grid>
            );
        }
        return (
            <Dialog maxWidth="md" open={true}>
                <DialogTitle variant="h4">View Details</DialogTitle>
                <DialogContent>{components}</DialogContent>
                <DialogActions>
                    <Button onClick={() => setViewRow(null)}>Close</Button>
                </DialogActions>
            </Dialog>
        );
    };

    const createRegionColumns = (validationErrors, setValidationErrors) => {
        return [
            {
                accessorKey: 'id',
                header: 'Id',
                enableEditing: false,
                muiEditTextFieldProps: {
                    type: 'number',
                    hidden: true,
                },
            },
            {
                accessorKey: 'name',
                header: 'Name',
                muiEditTextFieldProps: {
                    type: 'text',
                    required: true,
                    error: !!validationErrors?.name,
                    helperText: validationErrors?.name,
                    onFocus: () =>
                        setValidationErrors({
                            ...validationErrors,
                            name: undefined,
                        }),
                },
            }
        ];
    };

    const meterValidationSchema = yup.object().shape({
        name: yup.string().required('Name is required').max(255, 'Name must be no longer than 255 characters'),
    });

    return <CatalogEntity entityType={'regions'}
                          entityName={'Region'}
                          createColumns={createRegionColumns}
                          validationSchema={meterValidationSchema}
                          customViewDialog={ViewRegionDialog}
                          enums={enums}
    />;
}

export default RegionEditor;
